// Copyright (c) 2017 Deere & Company

export const buildAuditDealerString = (leadAccount, city, state) => {

    const stateSeperator = (state === '') ? '' : ', ';

    if (leadAccount === '') {

        return '---';

    }

    return `${leadAccount} - ${city}${stateSeperator}${state}`;

};



// WEBPACK FOOTER //
// ./src/tcsm/shared/services/build-audit-dealer-string.js